import { Info, Language } from '@audio-network/componentlibrary/icons'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import Help from '../Help/Help'
import LanguageSelector from '../LanguageSelector/LanguageSelector'
import { languages } from '../LanguageSelector/LanguageSelector.constants'
import SidebarNav from '../SidebarNav/SidebarNav'
import SidebarNavItem from '../SidebarNavItem/SidebarNavItem'
import styles from './FurtherInfo.module.css'

const FurtherInfo = (): JSX.Element => {
	const { t } = useTranslation(['navigation'])
	const { locale } = useRouter()

	return (
		<SidebarNav className={styles.furtherInfo} aria-label={t('further-info')}>
			<li>
				<SidebarNavItem
					startIcon={<Info />}
					content={t('help')}
					popovertarget="sidebar-help"
				/>
			</li>
			<Help className={styles.popover} id="sidebar-help" />
			<li>
				<SidebarNavItem
					aria-label={t('choose-language')}
					startIcon={<Language />}
					content={
						languages.find((language) => language.locale === locale)?.language
					}
					popovertarget="language"
				/>
			</li>
			<LanguageSelector className={styles.popover} id="language" />
		</SidebarNav>
	)
}

export default FurtherInfo
